/**
 * Every way back into an archive, in one place.
 *
 * "Sign in" used to call the passkey straight out, which was wrong twice over.
 * Most people here signed up with Google and have never seen a passkey, so the
 * operating system's fingerprint sheet appears with no explanation of what it
 * wants. And when the service holds the key — the default since D-011 — the
 * account has no passkey at all, so the one door on offer could not open.
 *
 * So it asks instead of guessing. Google first, because that is how most
 * accounts here were made; the other two below it, named for what they are.
 */
export function SignIn({ busy, canGoogle, canApple, canPasskey, canRecovery,
                         onGoogle, onApple, onPasskey, onRecovery, onClose }: {
  busy: boolean;
  canGoogle: boolean;
  /** Apple, which the App Store requires beside any third-party login. */
  canApple: boolean;
  canPasskey: boolean;
  /** The twenty-four words. Offered only where Google is not the way in:
   *  signing in with Google on a device with no passkey already lands on the
   *  screen that asks for them, so this is a shortcut rather than the route,
   *  and three doors for a product with one made the one look uncertain. */
  canRecovery: boolean;
  onGoogle: () => void;
  onApple: () => void;
  onPasskey: () => void;
  onRecovery: () => void;
  onClose: () => void;
}) {
  return (
    <div className="sheet" role="dialog" aria-modal="true" aria-label="Sign in">
      <div className="sheet-body">
        <header>
          <h2>Sign in</h2>
          <button className="x" onClick={onClose} aria-label="Close">×</button>
        </header>

        <div className="ways">
          {canGoogle && (
            <button className="way" disabled={busy} onClick={onGoogle}>
              <strong>Continue with Google</strong>
              <span className="fine">The account you signed up with.</span>
            </button>
          )}
          {canApple && (
            <button className="way ghost" disabled={busy} onClick={onApple}>
              <strong>Continue with Apple</strong>
              <span className="fine">Your Apple account. It can hide your email
                 from us, and we ask for nothing else.</span>
            </button>
          )}
          {canPasskey && (
            <button className="way ghost" disabled={busy} onClick={onPasskey}>
              <strong>Use a passkey</strong>
              <span className="fine">If you set one up on this device — Face ID,
                 a fingerprint, or your screen lock.</span>
            </button>
          )}
          {canRecovery && (
          <button className="way ghost" disabled={busy} onClick={onRecovery}>
            <strong>Use a recovery code</strong>
            <span className="fine">The twenty-four words you were given. Use this
               when you have lost every device that could open the archive.</span>
          </button>
          )}
        </div>
      </div>
    </div>
  );
}
